const Tracking = require('tracking/tracking-controller.js');

(function(root, doc, undefined) {

    'use strict';

    let trackingData = {};

    const getPageIdentifier = () => {
        return doc.body.getAttribute('data-page-identifier') || null;
    };

    const getInterfaceLang = () => {
        return root.BUSUU_GLOBALS.LANG_INTERFACE || null;
    };

    const getTrackingKey = () => {
        const pageId = getPageIdentifier();
        switch (pageId) {
            case 'home':
            case 'welcome':
            case 'hello':
                trackingData = {
                    page: pageId,
                    interface_language: getInterfaceLang()
                };
                return 'PAGE_VIEW_HOME';
        }
    };

    const sendPageTracking = () => {
        const key = getTrackingKey();
        if (key) {
            Tracking.send(key, trackingData);
        }
    };

    const init = () => {
        sendPageTracking();
    };

    init();

})(window, document);
